import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'appOptionValueToLabelPipe' })
export class OptionValueToLabelPipe implements PipeTransform {
    /**
     * transform
     *
     * @param value type of option
     * @param option å¤éåè¡¨
     * @param valueField ç»æå­æ®µ
     * @param labelField è¦è½¬æ¢çé£ä¸ªå­æ®µçå¼
     */
    public transform(value: any, valueField: string, labelField: string, option: any[]): String {
        let result = '';
        option.forEach( res => {
            if (res[valueField] === value) {
                result = res[labelField];
            }
        });
        return result;
    }
}

@NgModule({
    declarations: [OptionValueToLabelPipe],
    exports: [OptionValueToLabelPipe]
})
export class OptionValueToLabelPipeModule {
}
